module.exports = __webpack_public_path__ + "img/Hypoxia-CRC_GSE225857.56f332ac.png";